export default function cloneObject (dirtyObject) {
  dirtyObject = dirtyObject || {}
  var object = {}

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      object[property] = dirtyObject[property]
    }
  }

  return object
}



//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/cloneObject/index.js
// module id = Fg9Y
// module chunks = 52